module.exports = __webpack_public_path__ + "static/media/TITAN Buyer Manual_Oct-2020_EN_vf.7dbbb4d9.pdf";